import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  imports: [TranslateModule, RouterModule],
})
export class WelcomeComponent {
  title = 'reflex-rsp-frontend2';
}
